import { observer } from "mobx-react-lite"
import React, { FC, useEffect, useState } from "react"
import { Appearance, ViewStyle } from "react-native"
import { Screen } from "../../../components"
// import { useStores } from "../../models"
import { CompositeScreenProps } from "@react-navigation/native"
import { Spinner } from "native-base"
import WebView from "react-native-webview"
import { color } from "../../../theme"


const ROOT: ViewStyle = {
  flex: 1,
  backgroundColor: color.background
}

const OVERLAY: ViewStyle = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  justifyContent: 'center',
  alignItems: 'center'
}

export const PolicyScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function PolicyScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  // Pull in one of our MST stores
  // const { someStore, anotherStore } = useStores()
  const url = 'https://jala.tech/id/privacy-policy/';
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
  }, [])

  const handleLoading = () => setLoading(false);

  return (
    <Screen style={ROOT} preset="scroll" colorScheme={colorScheme} backgroundBar={color.primary} statusBar="light-content">
      <WebView source={{ uri: url }} onLoad={handleLoading} />
      {loading && <Spinner style={OVERLAY} size="lg" />}
    </Screen>
  )
})
